import Check from '../../../assets/icons/check-icon.png';

export const items = [
  {
    icon: Check,
    text: 'Kits de Ensaio',
  },
  {
    icon: Check,
    text: 'Vídeos',
  },
  {
    icon: Check,
    text: 'Playbacks e Letras',
  },
  {
    icon: Check,
    text: 'Curso online',
  },
  {
    icon: Check,
    text: 'Arranjos cifrados',
  },
  {
    icon: Check,
    text: 'Live Semanal',
  },
];
